import { render, staticRenderFns } from "./account-msisdn.vue?vue&type=template&id=5fae9004&"
import script from "./account-msisdn.vue?vue&type=script&lang=js&"
export * from "./account-msisdn.vue?vue&type=script&lang=js&"
import style0 from "./account-msisdn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports